/**
 * Extended ViewController template
 *
 * User: adic
 * Date: 12/11/12
 * Time: 1:33 PM
 */
define(function (require) {

    window.lpTag = window.lpTag || {};
    window.lpTag.WebAgent = window.lpTag.WebAgent || {};

    var App = window.App || {};
    var lpUtils = require('utils/lpUtils');
    var ViewController = require('web-agent-framework/ViewController');
    // var MainViewController = require('web-agent-viewControllers/MainViewController');
    var lpAgent = require('web-agent-assets-js/lpAgent');

    var AccountWidgetViewController = ViewController.extend({
        ControllerName: "AccountWidgetViewController",

        initialize: function () {
            this.menuVisible = false;
            this.view.tabIndex = 100;
            this.inDebug = false;
            this.playSound = true;
            this.getFirstElement(this.LPViewMap.toggleSoundsTitle).innerHTML = this.translate("muteSounds");
        },
        events: function () {
            this.bindModel({modelPath: "agent.displayName", callback: this.setAgentName});
            this.bindModel({modelPath: "agent.lpNumber", callback: this.setAccount});
            this.bindModel({modelPath: "agent.skillsInfo", callback: this.setSkillsInfo});
            this.bindModel({modelPath: "agent.status", callback: this.statusChanged});
            this.bindViewEvent({ DOMEvent: "click", callback: this.showAccountInfo});
            this.bindViewEvent({ selector:this.LPViewMap.toggleDebug,  DOMEvent: "click", callback: this.toggleDebugMode});
            this.bindViewEvent({ selector:this.LPViewMap.toggleSound,  DOMEvent: "click", callback: this.toggleSound});
            this.bindViewEvent({ DOMEvent: "blur", callback: this.hideAccountInfo, ignoreChildBlur: true });
            this.bindViewEvent({selector:this.LPViewMap.signOut, DOMEvent:"click" , callback:this.signOut});
            this.bindViewEvent({selector:this.LPViewMap.menuToggle, DOMEvent:"click" , callback:this.toggleView});
        },
        render: function () {}
    });

    AccountWidgetViewController.prototype.LPViewClasses = {
        active: "active",
        muteIcon: "mute",
        muteTitleIcon: "sound_notif"
    };

    AccountWidgetViewController.prototype.LPViewMap = {
        agentName: ".lpview_agent_name",
        agentNameLarge: ".lpview_agent_name_large",
        accountBody: ".lpview_account_body",
        accountNumber: ".lpview_account_number",
        skills: ".lpview_skills",
        signOut: ".lpview_signout_agent",
        menuContainer: ".lpview_menu_container",
        menuToggle: ".lpview_menu_toggle_item",
        toggleDebug: ".lpview_debug_mode",
        toggleSound: ".lpview_sound_mode",
        toggleSoundsTitle: ".lpview_sound_title",
        toggleSoundsIcon: ".lpview_sound_icon",
        soundMuteIcon: ".lpview_grey_sound_icon"
    };

    AccountWidgetViewController.prototype.signOut = function (e) {
        this.hideAccountInfo();
        this.stopPropagation(e);
        this.touchSession();

        if (lpTag.WebAgent.logicController.logoutMethod) {
            lpTag.WebAgent.logicController.logoutMethod(true);
        } else {
            this.showDialog({
                title: this.translate("signoutTitle"),
                description: this.translate("signoutDescription"),
                okButton: this.translate("signOut"),
                cancelButton: this.translate("cancel"),
                okCallback: this.disconnectOkClicked,
                targetView: window.MainViewControllerBody,
                modal: true
            });
        }
    };

    AccountWidgetViewController.prototype.disconnectOkClicked = function (e) {
        this.modelController.logOutAgent();
    };

    AccountWidgetViewController.prototype.toggleView = function (e) {
        if (this.menuVisible) {
            this.hideAccountInfo();
        }
        else {
            this.showAccountInfo();
        }
        this.stopPropagation(e);
        this.touchSession();
    };

    AccountWidgetViewController.prototype.toggleDebugMode = function (e) {
        this.stopPropagation(e);
        this.touchSession();
        this.inDebug = !this.inDebug;
        this.getFirstElement(this.LPViewMap.toggleDebug).innerHTML = this.inDebug ? this.translate("disableDebug") : this.translate("enableDebug");
        lpAgent.agent.setDebugMode(this.inDebug);
    };

    AccountWidgetViewController.prototype.toggleSound = function (e) {
        this.playSound = !this.playSound;
        var toggleSoundTitle = this.getFirstElement(this.LPViewMap.toggleSoundsTitle);

        if (this.playSound) {
            toggleSoundTitle.innerHTML = this.translate("muteSounds");
            this.removeClass(this.LPViewMap.soundMuteIcon, this.LPViewClasses.muteTitleIcon);
            this.removeClass(this.LPViewMap.toggleSoundsIcon, this.LPViewClasses.muteIcon);
        } else {
            toggleSoundTitle.innerHTML = this.translate("playSounds");
            this.addClass(this.LPViewMap.soundMuteIcon, this.LPViewClasses.muteTitleIcon);
            this.addClass(this.LPViewMap.toggleSoundsIcon, this.LPViewClasses.muteIcon);
        }

        toggleSoundTitle = null;
        lpTag.WebAgent.soundManager.toggleSounds();
        this.stopPropagation(e);
        this.touchSession();
    };

    AccountWidgetViewController.prototype.showAccountInfo = function () {
        if (!this.menuVisible) {
            this.lpShow(this.LPViewMap.accountBody);
            this.addClass(this.LPViewMap.menuContainer, this.LPViewClasses.active);
            this.menuVisible = true;
        }
    };

    AccountWidgetViewController.prototype.hideAccountInfo = function () {
        if (this.menuVisible) {
            this.lpHide(this.LPViewMap.accountBody);
            this.removeClass(this.LPViewMap.menuContainer, this.LPViewClasses.active);
            this.menuVisible = false;
        }
    };

    AccountWidgetViewController.prototype.setAccount = function (data) {
        if (data.newValue) {
            this.getFirstElement(this.LPViewMap.accountNumber, this.view).innerHTML = data.newValue;
        }
    };

    AccountWidgetViewController.prototype.setAgentName = function (data) {
        if (data.newValue) {
            this.getFirstElement(this.LPViewMap.agentName, this.view).innerHTML = data.newValue;
            var agentLarge = this.getFirstElement(this.LPViewMap.agentNameLarge, this.view);
            agentLarge.innerHTML = data.newValue;
            agentLarge.setAttribute("title", data.newValue);
            agentLarge = null;
            var that = this;
            setTimeout(function () { // to prevent the webkit bug with long names
                that.lpShow();
            }, 0);
        }
    };

    AccountWidgetViewController.prototype.setSkillsInfo = function (data) {
        if (data.newValue) {
            data.newValue.skillInfo = data.newValue.skillInfo.constructor === Array ? data.newValue.skillInfo : [data.newValue.skillInfo];
            var skillsArray = data.newValue.skillInfo.slice(0);
            skillsArray.sort(lpUtils.getSortFunction('name'));
            var list = "";
            var separator = "";
            for (var i = 0; i < skillsArray.length; i++) {
                list = list + separator + skillsArray[i].name;
                separator = ", ";
            }
            skillsArray = null;

            var skillsElement = this.getFirstElement(this.LPViewMap.skills, this.view);
            skillsElement.innerHTML = list;
            skillsElement.setAttribute("title", list);
            skillsElement = null;
        }
    };

    AccountWidgetViewController.prototype.statusChanged = function (data) {
        if (data.newValue !== 'loggedIn' && typeof data.newValue != 'undefined') {
            this.dispose();
        }
    };


    return AccountWidgetViewController;

});
